/**
 * Page that, when visited, initiates log in
 */
import React from 'react';
import PropTypes from 'prop-types';
import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

const propTypes = {
  logInHandler: PropTypes.func.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      from: PropTypes.string,
    }),
  }),
};

const defaultProps = {
  location: null,
};

export default class LoginPage extends React.Component {
  componentDidMount() {
    const { location, logInHandler } = this.props;
    const verifiedLocation = location && location.state ? location.state.from : null;
    logInHandler(verifiedLocation);
  }

  render() {
    return <LoadingPlaceholder />;
  }
}

LoginPage.propTypes = propTypes;
LoginPage.defaultProps = defaultProps;
